import React from 'react';
import PageHeader from '../../components/PageHeader';
import { routes } from '../../routes';
import { useNamespacedTranslation } from '../../../../hooks/useNamespacedTranslation';
import { useFlairBreadcrumbHook } from '../../../../hooks/useFlairBreadcrumbHook';
import { CompensationReviewsList } from './CompensationReviewsList';

// Standalone (top-level) Compensation Reviews list, shown to reviewers/approvers
// who do not have access to Team -> People.
const CompensationReviewsListPage: React.FC = () => {
  const t = useNamespacedTranslation('compensationReviews');
  useFlairBreadcrumbHook([{ label: t('title') }]);

  return (
    <>
      <PageHeader title={t('title')} subtitle={t('list.subtitle')} />
      <CompensationReviewsList
        buildDetailUrl={(id) =>
          routes.compensationReviewStandaloneDetail.route.create({ id })
        }
      />
    </>
  );
};

export default CompensationReviewsListPage;
